import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import loadable from 'react-loadable'
import LoadingComponent from 'components/Loading'
import { sessionControl } from '../functions/handleUsers'

// 3rd
import 'styles/antd.less'
import 'styles/bootstrap/bootstrap.scss'
// custom
import "styles/layout.scss"
import "styles/theme.scss"
import "styles/ui.scss"
import "styles/vendors.scss"

let AsyncAppLayout = loadable({
  loader: () => import('components/Layout/AppLayout'),
  loading: LoadingComponent
})

let AsyncAccount = loadable({
  loader: () => import('routes/user'),
  loading: LoadingComponent
})

class App extends React.Component {

  handleSession = () => {
    sessionControl(
      f => {
        if (f.status) {
          // console.log('Pero solo aquilo')
        } else {
          localStorage.clear()
          if (!this.loginPath && !this.signUpPath && !this.passwordPath) {
            return <Redirect to={'/user/login'} />
          }
        }
      }
    )
  }

  componentDidMount = () => {
    this.handleSession()
  }

  render() {
    const { match, location } = this.props
    this.rootPath = location.pathname === '/' ? true : false
    this.loginPath = location.pathname === '/user/login' ? true : false
    this.signUpPath = location.pathname === '/user/sign-up' ? true : false
    this.passwordPath = location.pathname === '/user/forgot-password' ? true : false
    const isLogged = localStorage.getItem('logged')

    if ((this.rootPath || this.loginPath || this.signUpPath) && isLogged) {
      return <Redirect to={'/app/dashboard'} />
    }

    if (!isLogged && !this.loginPath && !this.signUpPath && !this.passwordPath) {
      return <Redirect to={'/user/login'} />
    }

    return (
      <Switch id="app">
        <Route path={`${match.url}app`} component={AsyncAppLayout} />
        <Route path={`${match.url}user`} component={AsyncAccount} />
      </Switch>
    )
  }
}


export default App